import {RemoteGetAccessManagementFeatures} from 'data/usecases';
import {GetAccessManagementFeatures} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AccessManagementEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetAccessManagementFeatures = (): GetAccessManagementFeatures =>
	new RemoteGetAccessManagementFeatures(
		makeBFFApiUrl(AccessManagementEndpoints.features),
		makeAuthorizeHttpClientDecorator(),
	);
